import GrowthBookContext from './GrowthBookFeaturesContext';

const GrowthBookFeaturesProvider = ({ children, features }) => {
  // TODO: Init growthbook here
  return <GrowthBookContext.Provider value={features}>{children}</GrowthBookContext.Provider>;
};

export default GrowthBookFeaturesProvider;
